import { useInfiniteQuery } from '@tanstack/react-query';
import { notesService, NOTE_KEYS } from '@/features/notes/public';
import type { NotePagedResult } from '@/features/notes/public';

const PAGE_SIZE = 20;

/**
 * Fetches the current user's notes with infinite/load-more pagination.
 * Used by `NotesPanel` — lives in shared/ to avoid a cross-feature import
 * from the layout component, same rationale as `useProjectsInfinite`.
 *
 * @remarks
 * Notes are user-scoped, not org-scoped — no `activeOrganizationId` involved.
 */
export function useNotesInfinite() {
  return useInfiniteQuery<NotePagedResult>({
    queryKey: NOTE_KEYS.listInfinite({}),
    queryFn: ({ pageParam }) =>
      notesService.getList({ page: pageParam as number, pageSize: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.page + 1 : undefined),
    staleTime: 120_000,
  });
}
